import { ProductType, } from '../../globalTypes';
import Slugifier from './Slugifier';
import { GeoTreeHelper, ProductTypeHelper } from '../../util';
var FormDataRouteCreator = /** @class */ (function () {
    function FormDataRouteCreator() {
    }
    FormDataRouteCreator.createRouteMap = function (flatProductGroups) {
        var _this = this;
        var groupIdToRoutes = {};
        var routeToGroupIds = {};
        var rootNodeId = 0;
        var packageParentNodeId = GeoTreeHelper.getAllDestinationsNodeId(ProductType.PACKAGE);
        var hotelParentNodeId = GeoTreeHelper.getAllDestinationsNodeId(ProductType.HOTEL);
        var slugifier = new Slugifier();
        var linkPaths = [];
        var recursiveRouteBuilder = function (coreStateGroupParam, productGroupIdParam, prefix) {
            if (prefix === void 0) { prefix = ''; }
            var currentNodeName = flatProductGroups[coreStateGroupParam][productGroupIdParam].name;
            var currentPath = prefix + slugifier.slugify(currentNodeName) + '/';
            if (flatProductGroups
                && flatProductGroups[coreStateGroupParam][productGroupIdParam]
                && flatProductGroups[coreStateGroupParam][productGroupIdParam].childrenIds
                && flatProductGroups[coreStateGroupParam][productGroupIdParam].childrenIds.length > 0) {
                flatProductGroups[coreStateGroupParam][productGroupIdParam].childrenIds.forEach(function (productGroupId) { return recursiveRouteBuilder(coreStateGroupParam, productGroupId, currentPath); });
            }
            currentPath = currentPath.substr(0, currentPath.length - 1);
            var currentGroupId = flatProductGroups[coreStateGroupParam][productGroupIdParam].id;
            if (_this.isItSelfOrAnyOfParentsLink(flatProductGroups[coreStateGroupParam], currentGroupId)) {
                linkPaths.push(currentPath);
            }
            if (!groupIdToRoutes[currentGroupId]) {
                groupIdToRoutes[currentGroupId] = currentPath;
            }
            else if (linkPaths.includes(groupIdToRoutes[currentGroupId])) {
                groupIdToRoutes[currentGroupId] = currentPath;
            }
            if (routeToGroupIds[coreStateGroupParam] === undefined) {
                routeToGroupIds[coreStateGroupParam] = {};
            }
            routeToGroupIds[coreStateGroupParam][currentPath] = currentGroupId;
            return null;
        };
        // Build routes for PACKAGE
        var coreStateGroup = ProductTypeHelper.mapToCoreStateGroup(ProductType.PACKAGE);
        if (flatProductGroups
            && flatProductGroups[coreStateGroup][packageParentNodeId]
            && flatProductGroups[coreStateGroup][packageParentNodeId].childrenIds
            && flatProductGroups[coreStateGroup][packageParentNodeId].childrenIds.length > 0) {
            flatProductGroups[coreStateGroup][packageParentNodeId].childrenIds.forEach(function (productGroupId) { return recursiveRouteBuilder(coreStateGroup, productGroupId); });
        }
        if (flatProductGroups
            && flatProductGroups[coreStateGroup][rootNodeId]
            && flatProductGroups[coreStateGroup][rootNodeId].childrenIds
            && flatProductGroups[coreStateGroup][rootNodeId].childrenIds.length > 0) {
            flatProductGroups[coreStateGroup][rootNodeId].childrenIds.forEach(function (productGroupId) { return recursiveRouteBuilder(coreStateGroup, productGroupId); });
        }
        // Build routes for HOTEL
        coreStateGroup = ProductTypeHelper.mapToCoreStateGroup(ProductType.HOTEL);
        if (flatProductGroups
            && flatProductGroups[coreStateGroup][hotelParentNodeId]
            && flatProductGroups[coreStateGroup][hotelParentNodeId].childrenIds
            && flatProductGroups[coreStateGroup][hotelParentNodeId].childrenIds.length > 0) {
            flatProductGroups[coreStateGroup][hotelParentNodeId].childrenIds.forEach(function (productGroupId) { return recursiveRouteBuilder(coreStateGroup, productGroupId); });
        }
        if (flatProductGroups
            && flatProductGroups[coreStateGroup][rootNodeId]
            && flatProductGroups[coreStateGroup][rootNodeId].childrenIds
            && flatProductGroups[coreStateGroup][rootNodeId].childrenIds.length > 0) {
            flatProductGroups[coreStateGroup][rootNodeId].childrenIds.forEach(function (productGroupId) { return recursiveRouteBuilder(coreStateGroup, productGroupId); });
        }
        var routeMap = {
            groupIdRouteMap: groupIdToRoutes,
            routeGroupIdMaps: routeToGroupIds
        };
        return routeMap;
    };
    FormDataRouteCreator.isItSelfOrAnyOfParentsLink = function (flatProductGroups, productGroupIdParam) {
        var rootNodeId = 0;
        var packageParentNodeId = GeoTreeHelper.getAllDestinationsNodeId(ProductType.PACKAGE);
        var hotelParentNodeId = GeoTreeHelper.getAllDestinationsNodeId(ProductType.HOTEL);
        if (Boolean(flatProductGroups[productGroupIdParam].properties.isLink)) {
            return true;
        }
        if (flatProductGroups[productGroupIdParam].parentId === rootNodeId ||
            flatProductGroups[productGroupIdParam].parentId === packageParentNodeId ||
            flatProductGroups[productGroupIdParam].parentId === hotelParentNodeId) {
            return false;
        }
        return this.isItSelfOrAnyOfParentsLink(flatProductGroups, flatProductGroups[productGroupIdParam].parentId);
    };
    return FormDataRouteCreator;
}());
export { FormDataRouteCreator };
export default FormDataRouteCreator;
